/**
 * One finding of the runtime analysis as a button: the severity chip and
 * the sentence, a press staging the question about it. Shared by the list
 * under the map and the part panel (2026-09-05), so the words the guide is
 * handed are defined once.
 */

import type { RuntimeFinding } from '../../api/types';

export const SEVERITY_CHIP: Record<string, string> = {
  risk: 'border-(--danger) text-(--danger)',
  drift: 'border-(--shifted) text-(--shifted)',
  note: 'border-default text-tertiary',
};

export const SEVERITY_WORD: Record<string, string> = {
  risk: 'Risk',
  drift: 'Drift',
  note: 'Note',
};

export function findingQuestion(message: string): string {
  return `${message}. What does that mean for us, and what should change?`;
}

export function FindingButton({
  finding: f,
  onAsk,
  testId = 'runtime-finding',
}: {
  finding: RuntimeFinding;
  onAsk: (question: string) => void;
  testId?: string;
}) {
  return (
    <button
      type="button"
      data-testid={testId}
      data-severity={f.severity}
      title={f.evidence.length > 0 ? `Evidence: ${f.evidence.join('; ')}` : 'Ask the guide about this'}
      onClick={() => onAsk(findingQuestion(f.message))}
      className="flex w-full cursor-pointer items-start gap-2 rounded-card border-none bg-transparent px-1 py-0.5 text-left text-[length:var(--text-ui-size)] text-secondary transition-colors duration-(--motion-hover) hover:bg-inset hover:text-primary"
    >
      <span
        className={`mt-0.5 shrink-0 rounded-pill border px-1.5 text-[length:var(--text-micro-size)] leading-[var(--text-micro-line)] ${SEVERITY_CHIP[f.severity] ?? SEVERITY_CHIP['note']}`}
      >
        {SEVERITY_WORD[f.severity] ?? f.severity}
      </span>
      <span className="min-w-0">{f.message}</span>
    </button>
  );
}
